import React from 'react'

import { Element, TextLink, TextLinkProps } from "components/shared/base"


const NavigationItem: React.FC<TextLinkProps> = ({
  href,
  text
}): React.ReactElement => {
  return (
    <Element as="li" ml="20px" my={["15px", "0"]}>
      <TextLink href={href} text={text} />
    </Element>
  )
}

export default NavigationItem
